<template>
  <modal name="countInput" :width="500" :height="'100%'"
    @opened="opened"
    @before-open="beforeOpen"
  >
    <div id="div_countInput" class="popup boundary">
      <div class="pop_tit">
        <span>실제 수량을 입력해 주세요.</span>
        <a href="javascript:void(0);" title="close" class="pop_close" @click="close">close</a>
      </div>
      <div class="pop_con_wrap">
        <div class="pop_con">
          <div class="pop_con_bg" style="height: 100px; padding: 20px;">
            <p style="margin-bottom: 10px;">
              체크된 회수 기기 수량: <strong>{{ checkedItemCnt }}</strong>
            </p>
            <DxNumberBox
              v-model="value"
              :min="0"
              :height="40"
            />
          </div>
        </div>
      </div>
      <div class="pop_footer_wrap">
        <div class="pop_btn_area">
          <button class="btn_type_01 delete" @click="confirm" >회수</button>
          <button class="btn_type_01" @click="close" >닫기</button>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import DxNumberBox from 'devextreme-vue/number-box'

export default {
  name: 'CountInput',
  components: {
    DxNumberBox
  },
  data: () => ({
    value: 0,
    originZindex: 0,
    checkedItemCnt: 0
  }),
  computed: {

  },
  created () {

  },
  mounted () {

  },
  watch: {

  },
  methods: {
    beforeOpen ({ params }) {
      if (params.checkedItem) {
        this.checkedItemCnt = params.checkedItem.length
      }
    },
    opened () {
      let popLeft = (($(window).width() - $('#div_countInput').outerWidth()) / 2)
      let popTop = (($(window).height() - $('#div_countInput').outerHeight()) / 2)
      if (popLeft < 0) popLeft = 0
      if (popTop < 0) popTop = 0
      $('#popupMask').fadeIn()
      $('#div_countInput').css({'left': popLeft, 'top': popTop}).fadeIn().addClass('on')

      this.originZindex = window.getComputedStyle(document.getElementsByClassName('v--modal-overlay')[0]).zIndex
      document.getElementsByClassName('v--modal-overlay')[0].style.zIndex = 998
    },
    close () {
      this.closed()

      document.getElementsByClassName('v--modal-overlay')[0].style.zIndex = this.originZindex

      this.value = 0
      this.$modal.hide('countInput')
    },
    closed () {
      $('#pop_up').fadeOut().removeClass('on')
      $('#popupMask').fadeOut()
    },
    async confirm () {
      // 실제 0개 회수 하는 경우도 있음... by 담당자
      // if (!this.value) {
      //   this.$Alert.alert('수량을 입력하세요.')
      //   return
      // }
      const res = await this.$Alert.confirm(`실제 회수 수량 ${this.value} 개가 맞나요?`)

      if (res) {
        this.$emit('popupComplete', { cntRelease: this.value })
        this.close()
      }
    }
  }
}
</script>

<style scoped>
.popup.boundary {
  width: 100%;
  height: 100%;
}
</style>

<style>
.boundary .dx-widget input {
  font-size: 20px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/normal/collect/CountInput.vue